import React from 'react';
import { Badge } from './ui/badge';

const THREAD = [
    { id: 't1', from: 'member', name: 'Sarah M.', text: "Hi Pastor James! In Romans 5:3-4, how do you apply 'suffering produces perseverance' in a hard season?", time: 'Tue 7:12 PM' },
    { id: 't2', from: 'teacher', name: 'Pastor James', text: "Great question, Sarah. I journal during hard seasons and look back to see how God was working. Want to talk more on Sunday?", time: 'Tue 8:40 PM' },
    { id: 't3', from: 'member', name: 'Sarah M.', text: "That really helps, thank you! See you Sunday.", time: 'Tue 8:52 PM' },
];

export const GuestSampleConversation = () => (
    <div className="flex flex-col h-full" data-testid="guest-messages-embedded">
        <div className="flex items-center justify-between pb-3">
            <p className="text-sm font-semibold">Pastor James</p>
            <Badge variant="outline" className="text-[10px]">Sample conversation</Badge>
        </div>
        <div className="flex-grow space-y-3 overflow-y-auto" data-testid="guest-sample-thread">
            {THREAD.map((m) => (
                <div key={m.id} className={`flex ${m.from === 'member' ? 'justify-end' : 'justify-start'}`}>
                    <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${m.from === 'member' ? 'bg-primary text-primary-foreground rounded-br-md' : 'bg-muted rounded-bl-md'}`}>
                        <p>{m.text}</p>
                        <p className={`text-[10px] mt-1 ${m.from === 'member' ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>{m.name} · {m.time}</p>
                    </div>
                </div>
            ))}
        </div>
        <div className="mt-4 rounded-xl border border-dashed border-border p-3 text-center text-sm">
            <span className="text-muted-foreground">Members can message their leader privately. </span>
            <a href="/" className="text-primary font-semibold hover:underline" data-testid="guest-dm-signup-link">Sign up free</a>
        </div>
    </div>
);

export default GuestSampleConversation;
